import { useState, useRef, useEffect } from 'react';
import { StyledButton, StyledInput } from '../StyledComponents';
import * as XLSX from 'xlsx';
import Handsontable from 'handsontable';

import warning from '../../assets/warning.png'
import '../../styles/SeeData.css';
import 'handsontable/dist/handsontable.full.min.css';

const SeeDataView = ({ setView, data, file, setFile }) => {

  const hotTableContainer = useRef(null);
  const hotInstance = useRef(null);
  const [fileName, setFileName] = useState(file.name.substring(0, file.name.length - 4) );
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (!hotInstance.current && hotTableContainer.current) {
      hotInstance.current = new Handsontable(hotTableContainer.current, {
        data: [],
        rowHeaders: true,
        colHeaders: true,
        width: 'auto',
        minSpareRows: 3,
        minSpareCols: 3,
        autoWrapRow: true,
        autoWrapCol: true,
        preventOverflow: 'horizontal',
        licenseKey: 'non-commercial-and-evaluation',
      });
      showData();
    }

    return () => {
      if (hotInstance.current) {
        hotInstance.current.destroy();
        hotInstance.current = null;
      }
    };
  });

  const showData = async () => {
    hotInstance.current.loadData(data.structuredData);
  }

  const handleDownload = () => {
    if (fileName.length !== 0) {
      const data = hotInstance.current.getData();
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Hoja1');
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
      setOpenModal(false);
    }
  };

  const handleChangeInput = (e) => {
    if (e.target.value.match(/^(?!\s)(?!.*\s$)[^<>:"/\\|?*]*$/) !== null) {
      setFileName(e.target.value);
    }
  };

  return (
    <div className="mainContainer">
      <div className="fileButtons">
        <StyledButton className="fileButtons2" style={{ border: fileName.length !== 0 ? `4px solid var(--Success-color)` : `4px solid #666666` }} onClick={()=> setOpenModal(true)} disabled={fileName.length === 0} >Descargar Archivo Editado</StyledButton>
        <StyledButton className="fileButtons2" style={{ border: `4px solid var(--Success-color)`}} onClick={() => { setFile(null); setView("UploadFile");}}>Convertir Otro Archivo</StyledButton>
      </div>
      <div className="excelContainer">
        <div className="filenameContainer">
          <div className="filenameName">
            Nombre del Archivo:
          </div>
          <StyledInput className="filenameNameInput" type="text" id="name" name="name" size="auto" value={fileName} onChange={handleChangeInput}/>
        </div>
        <div className="tableContainer">
          <div id="hot" ref={hotTableContainer}></div>
        </div>
      </div>
      
      {openModal && (
        <div className="modalContainer">
          <div className="modalInnerContainer">
            {/* <button className="closeButton">X</button> */}
            <div className="iconContainer">
              <div className="iconSubContainer">
                <img src={warning} className="iconStyle" alt="Warning Icon"/>
              </div>
            </div>
            <p className="modalText">La conversión puede contener errores.</p>
            <p className="modalText">Verifique la información antes de usarla.</p>
            <p className="modalDisclaimerText">* No nos hacemos responsables por inexactitudes o daños. *</p>
            <div className="modalButtonsContainer">
              <StyledButton className="modalButtonsCancel" onClick={() => setOpenModal(false)} >Cerrar</StyledButton>
              <StyledButton className="modalButtonsAccept" onClick={handleDownload} >Aceptar</StyledButton>
            </div>
          </div>
        </div>
      )}
    </div>
  )
};

export default SeeDataView